module.exports = __webpack_public_path__ + "static/media/biocertica-logo-with-text-black-vertical.96dedd3b.svg";